import React from 'react';
import { formatNumber } from '../../../utils/number';
import { noData } from '../../../utils/string';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import StarBorderIcon from '@material-ui/icons/StarBorder';

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: 'flex',
    flexDirection: ({ ownPage }: any) => {
      return ownPage ? 'column' : 'row';
    },
    alignItems: 'center',
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: ({ ownPage }: any) => {
      return ownPage ? 'center' : 'flex-start';
    },
  },
  star: {
    fontSize: theme.spacing(11),
    marginRight: ({ ownPage }: any) => {
      return ownPage ? 0 : theme.spacing(2);
    },
  },
  header: { fontWeight: 'bold' },
  profit: {
    color: theme.palette.brand.green,
    fontWeight: 'bold',
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(0),
  },
  returnRate: {
    color: theme.palette.brand.green,
    fontWeight: 'bold',
    fontSize: '1.2em',
  },
  text: { marginBottom: theme.spacing(1) },
}));

export default function BottomLine({ plan, ownPage = false }) {
  const classes = useStyles({ ownPage });

  return (
    <div id="bottom-line" className={classes.root}>
      <div className={classes.section}>
        <StarBorderIcon className={classes.star} />
      </div>
      <div className={classes.section}>
        {ownPage && (
          <Typography variant="h4" className={classes.header}>
            The Bottom Line
          </Typography>
        )}
        <Typography paragraph className={classes.text}>
          Once complete, your Growth Plan will generate you a net of
        </Typography>
        <Typography variant="h3" paragraph className={classes.profit}>
          {plan?.netProfit
            ? `$${formatNumber(Math.round(plan.netProfit))}`
            : noData()}
        </Typography>
        {plan?.returnRate && (
          <Typography paragraph>
            <span>representing a return rate of</span>{' '}
            <span className={classes.returnRate}>
              {formatNumber(plan.returnRate)}X
            </span>
          </Typography>
        )}
      </div>
    </div>
  );
}
